import { z } from 'zod';

import { MESSAGE_DATA_TYPES } from './discriminators';

/**
 * Marks an inquiry as coming from Fellows Corner.
 *
 * Carries no mentor fields. The recipient already identifies the mentor, and the
 * backend reads this discriminator to stamp the type onto the inquiry itself,
 * which is where consumers should read it from. A mentor id here would duplicate
 * the recipient, and a mentor name would be frozen at submission time.
 */
export const payloadSchema = z.object({
  type: z.literal(MESSAGE_DATA_TYPES.MENTOR_INQUIRY),
});

export type MentorInquiryMessageData = z.infer<typeof payloadSchema>;

export const attributesSchema = z.object({});

export function createMentorInquiryMessageData(): MentorInquiryMessageData {
  return { type: MESSAGE_DATA_TYPES.MENTOR_INQUIRY };
}
